import React, { createContext, useContext, useMemo } from 'react';

import PropTypes from 'prop-types';

import { BUILDER_MODELS } from '~/builder/constants/models';

const GridVariantContext = createContext({
  gridVariant: null,
  isSaleGrid: false,
});

export const GridVariantProvider = ({ children, gridVariant }) => {
  const contextValue = useMemo(() => {
    return {
      gridVariant,
      isSaleGrid: gridVariant === BUILDER_MODELS.SALE_PAGE,
    };
  }, [gridVariant]);

  return (
    <GridVariantContext.Provider value={contextValue}>
      {children}
    </GridVariantContext.Provider>
  );
};

GridVariantProvider.propTypes = {
  children: PropTypes.node.isRequired,
  gridVariant: PropTypes.string,
};

export const useGridVariant = () => {
  return useContext(GridVariantContext);
};
